import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import SocialSecurity from '../../../../../../components/SocialSecurity/SocialSecurity';
import UseContext from '../../../../../../hooks/useContext';
import Usefetchdata from '../../../../../../hooks/usefetchdata';
import ApiDatabase from '../../../../../../server';
import Banner from '../../../../../banner/banner';
import Divider from '../../../../../divider/divider';
import ModalBody from '../../../../components/body';
import UseModal from '../../../../useModal';

import {
  DocumentViewer,
  DocumentSidebar,
  ModalHeader,
  UserInfoGrid,
  ValidationActions,
  useAdminModalFiles,
  useAdminModalTempWorker,
  useAllUserDocuments,
  openNextUnverifiedDocument,
} from '../shared';

const AdminModalFileAcceptVitalCard = () => {
  const { toggle } = UseModal();
  const {
    adminType,
    adminTempWorkerId,
    adminUserId,
    adminFileName,
    setUpdateTempWorker,
    setOpenModal,
    setAdminType,
  } = UseContext();
  const { userData } = Usefetchdata();
  
  const [numberVitalCard, setNumberVitalCard] = useState('');
  
  const token = localStorage.getItem('xsrfToken');

  // Hooks centralisés
  const { docs, isWaiting } = useAdminModalFiles({
    token,
    adminUserId,
    adminType,
    adminFileName,
    enabled: !!userData._id && !!adminUserId && !!adminType,
  });

  const { tempWorker, user } = useAdminModalTempWorker({
    token,
    adminTempWorkerId,
    enabled: !!userData._id && !!adminTempWorkerId,
  });

  // Récupérer tous les documents de l'utilisateur pour la sidebar
  const { allDocuments, isLoading: isLoadingAllDocs } = useAllUserDocuments({
    token,
    adminUserId,
    currentType: adminType,
    enabled: !!userData._id && !!adminUserId && !isWaiting,
  });

  // Charger les données existantes du tempWorker
  useEffect(() => {
    if (tempWorker._id) {
      setNumberVitalCard(tempWorker.card_vitality?.social_security ?? '');
    }
  }, [tempWorker]);

  const modalAcceptSubmit = () => {
    if (token && adminTempWorkerId && adminType && numberVitalCard) {
      ApiDatabase.postAcceptTempWorkerFileVitalCardAdmin(
        { token, adminTempWorkerId, adminType, numberVitalCard },
        (data) => {
          toast.success('Le fichier a été accepté');
          setUpdateTempWorker({ tempWorkerId: data._id, documentType: adminType });
          
          // Ouvrir le prochain document non vérifié
          openNextUnverifiedDocument({
            tempWorker,
            allDocuments,
            currentType: adminType,
            setAdminType,
            setOpenModal,
            toggle,
          });
        },
        (err) => {
          if (err.name !== 'CanceledError') console.log(err);
        }
      );
    } else {
      toast.error('Veuillez remplir tous les champs');
    }
  };

  const handleRefuse = () => {
    toggle();
    setOpenModal('ad_file_refuse');
  };

  const handleOpenDocumentModal = (type, modalName) => {
    setAdminType(type);
    toggle();
    setOpenModal(modalName);
  };

  return (
    <ModalBody>
      <div className="flex gap-4 h-[750px]">
        {/* Section 1: Autres documents */}
        <DocumentSidebar
          allDocuments={allDocuments}
          isLoading={isLoadingAllDocs}
          currentType={adminType}
          onOpenDocumentModal={handleOpenDocumentModal}
          tempWorker={tempWorker}
        />
        
        {/* Section 2: Document Viewer */}
        <div className="flex-1 min-w-0 bg-gray-50 rounded-lg overflow-hidden">
          <DocumentViewer docs={docs} isWaiting={isWaiting} />
        </div>
        
        {/* Section 3: User Info + Inputs + Boutons */}
        <div className="w-80 flex flex-col gap-3 bg-gray-50 rounded-lg p-4 overflow-y-auto">
          <ModalHeader
            adminType={adminType}
            tempWorker={tempWorker}
            docsCount={docs.length}
            onClose={toggle}
          />
          
          <UserInfoGrid
            user={user}
            validationStatus={tempWorker.card_vitality?.validated}
            reason={tempWorker.card_vitality?.reason}
            showBirthday={true}
          />
          
          <Divider />
          
          <div className="w-full">
            <Banner type="info">
              Pour les intérimaires étrangers, veuillez n'indiquer que les 10
              premiers chiffres du numéro de la carte vitale
            </Banner>
          </div>
          
          <div className="w-full">
            <SocialSecurity
              socialSecurity={numberVitalCard}
              setSocialSecurity={setNumberVitalCard}
            />
          </div>
          
          <ValidationActions onRefuse={handleRefuse} onAccept={modalAcceptSubmit} />
        </div>
      </div>
    </ModalBody>
  );
};

export default AdminModalFileAcceptVitalCard;
